import { CurrencyFormat } from "common/helpers/Format";
import { List, Record } from "immutable";
import { v4 as uuid } from "uuid";

export const estimatePaymentTermItemFromJSON = (
  json: Partial<IEstimatePaymentTermItemData>,
  forceUuid = true,
): EstimatePaymentTermItemRecord => {
  const record: IEstimatePaymentTermItemRecord = { ...(json as any) };

  if (!record.uuid && forceUuid) {
    record.uuid = uuid();
  }

  return new EstimatePaymentTermItemRecord(record);
};

export const PaymentTermItemTypeList: List<PaymentTermItemTypes> = List<PaymentTermItemTypes>(["percent", "amount"]);
export type PaymentTermItemTypes = "percent" | "amount";

export const formatAmount = (item: EstimatePaymentTermItemRecord | undefined) => {
  if (!item) return "";

  if (item.type === "percent") return item.amount.toString() + "%";
  return CurrencyFormat(item.amount || 0);
};

export interface IEstimatePaymentTermItemData {
  uuid: string;
  amount: number;
  description: string;
  type: PaymentTermItemTypes;
  calculated: number;
  paymentMethod: "cash" | "financed";
}

export interface IEstimatePaymentTermItemRecord {
  uuid: string;
  amount: number;
  description: string;
  type: PaymentTermItemTypes;
  calculated: number;
  paymentMethod: "cash" | "financed";
}

const defaultEstimatePaymentTermItemProps: IEstimatePaymentTermItemRecord = {
  uuid: "",
  amount: 0,
  description: "",
  type: "amount",
  calculated: 0,
  paymentMethod: "cash",
};

export class EstimatePaymentTermItemRecord
  extends Record(defaultEstimatePaymentTermItemProps)
  implements IEstimatePaymentTermItemRecord {}
